import { render } from "./ArrowRightSmallIcon.vue?vue&type=template&id=f5e8753c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__